module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.store.viewLoader || !_vm.store.selfDataLoaded),
      expression: "store.viewLoader || !store.selfDataLoaded"
    }],
    attrs: {
      "id": "loader"
    }
  }, [_c('transition', {
    attrs: {
      "name": "loader-transition"
    }
  }, [_c('div', {
    staticClass: "loader-bg"
  }, [_c('div', {
    staticClass: "loader-img"
  })])])], 1), _vm._v(" "), (_vm.store.selfDataLoaded) ? _c('top-bar') : _vm._e(), _vm._v(" "), (_vm.store.selfDataLoaded) ? _c('div', {
    attrs: {
      "id": "router"
    }
  }, [_c('transition', {
    attrs: {
      "name": "router-transition"
    }
  }, [_c('router-view')], 1)], 1) : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "id": "alerts",
      "tag": "div",
      "name": "alert-transition"
    }
  }, _vm._l((_vm.alerts), function(alert, key) {
    return _c('div', {
      key: key,
      staticClass: "alert",
      style: ({
        'background-color': alert.color
      })
    }, [_c('div', {
      staticClass: "alert-text",
      domProps: {
        "innerHTML": _vm._s(alert.text)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "alert-cross",
      on: {
        "click": function($event) {
          _vm.removeAlert(key)
        }
      }
    })])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78ee21cc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 208
// module chunks = 0